<template>
	<b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <plate-create-or-update v-model="plate" :errors="errors" :editing="editing" :hgs-classes="hgsClasses" :hgs-vehicle-types="hgsVehicleTypes" />
            <template #modal-footer><v-executer  :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="plate"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"
                    ></v-table>

        <b-modal id="hgs-history-modal"
                :title="`${selectedPlateForHgs.PlateValue} Plakası HGS Geçmişi`"
                size="lg"
                body-class="p-0"
                hide-footer 
                no-close-on-esc
                no-close-on-backdrop
                v-on:hidden="refreshMainTable">

            <plate-h-g-s-classification :plate="selectedPlateForHgs" :hgs-classes="hgsClasses" :hgs-vehicle-types="hgsVehicleTypes" />

        </b-modal>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import PlateCreateOrUpdate from './components/PlateCreateOrUpdate.vue'
import PlateHGSClassification from './PlateHGSClassificationView.vue'
import PlateApi from '@/api/vehicle-operations'
import SelectApi from '@/api/select'

export default {
	components:{
        BCard,
        PlateCreateOrUpdate,
        PlateHGSClassification,
	},
	data(){
		return{
			editing:false,
            loading:false,
            errors:{},
            plate:{
                Id:0,
                PlateValue:null,
                IsSold:false,
                SoldDate:null,
                HGSNumber:null,
                HGSStartDate:null,        
                HGSClass:null,
                HGSVehicleClassType:null  
            },
            selectedPlateForHgs:{ Id:null, PlateValue:null },
            hgsClasses: [],
            hgsVehicleTypes: [],
            fields:[
                { name:"Plaka",key:"PlateValue", thClass:"w-25",sortable:true},
                { name:"Bağlı Olduğu Araç Envanter Kodu",key:"VehicleInventoryInventoryNo", thClass:"w-50",sortable:true,sortKey:'VehicleInventory.InventoryNo'},
                { name:"Satıldı",key:"IsSold",sortable:true},
                { name:"Satılma Tarihi",key:"SoldDateStr", thClass:"w-25",sortable:true},
                { name:"HGS Numarası",key:"HGSNumber", thClass:"w-25",sortable:true},

            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                { text:"HGS Geçmişi",key:"hgs-history",icon:"LayersIcon",variant:"info",action:this.openHgsHistory },
            ]
		}
	},
    created(){
        this.fetchEnums();
    },
	methods:{
        clearForm(){
            this.editing = false
            this.errors = {}
            this.plate.Id = 0
            this.plate.PlateValue = null
            this.plate.IsSold = false
            this.plate.SoldDate = null
            this.plate.HGSNumber = null
            this.plate.HGSStartDate = null
            this.plate.HGSClass = null
            this.plate.HGSVehicleClassType = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.loading = true

            this.plate.Id = item.Id
            this.plate.PlateValue = item.PlateValue
            this.plate.IsSold = item.IsSold
            this.plate.SoldDate = item.SoldDate

            PlateApi.HGSClassification.GetByPlateId(item.Id)
            .then(res => {
                if(res.data.Success && res.data.Data.length > 0){
                    const latestHgs = res.data.Data[0]
                    this.plate.HGSNumber = latestHgs.HGSNumber
                    this.plate.HGSStartDate = latestHgs.HGSStartDate
                    this.plate.HGSClass = latestHgs.HGSClass
                    this.plate.HGSVehicleClassType = latestHgs.HGSVehicleClassType
                }
            })
            .catch(err => {
                this.$result(null, err) 
            })
            .finally(() => {
                this.loading = false
                this.$showModal('create-or-update')
            })
        },
        openHgsHistory(item){
            this.selectedPlateForHgs = item;
            this.$bvModal.show('hgs-history-modal');
        },
        refreshMainTable() {
            this.$refs.table.refresh();
        },
        fetchEnums() {
            SelectApi.GetEnum('HGSClass').then(res => {
                if (res.data.Success) this.hgsClasses = res.data.Data;
            })
            SelectApi.GetEnum('HGSVehicleClassType').then(res => {
                if (res.data.Success) this.hgsVehicleTypes = res.data.Data;
            })
        },
        provider(data) {
            return PlateApi.Plate.Table(data)
        },
        createOrUpdate(){
            this.errors = {}
            if (!this.editing) {
                this.plate.HGSNumber = this.normalizeHGSNumber(this.plate.HGSNumber)
            }

            if (!this.editing && this.plate.HGSNumber && this.plate.HGSNumber.length !== 10) {
                this.errors.HGSNumber = 'HGS etiketi 10 karakter olmalidir.'
                return
            }

            this.loading = true
            PlateApi.Plate.CreateOrUpdate(this.editing,this.plate)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.errors = this.getValidationErrors(err)
                this.$result(null,err)
                this.loading = false
            })
        },
        normalizeHGSNumber(value) {
            if (!value) return null
            const normalizedValue = value.toString().trim().replace(/\s+/g, '').toUpperCase()
            return normalizedValue || null
        },
        getValidationErrors(err) {
            const responseData = err?.response?.data || {}
            return responseData.Data || responseData.Errors || {}
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} plakasını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    PlateApi.Plate.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
	}
}
</script>

<style>

</style>
